import { z } from "zod";

export const stacksServices = [
  { id: "scholarly", name: "Scholarly Stacks" },
  { id: "research", name: "Research Stacks" }
] as const;
export const stacksServiceId = z.enum(["scholarly", "research"]);
export type StacksServiceId = z.infer<typeof stacksServiceId>;
export type StacksService = { id: StacksServiceId; name: string; configured: boolean };
export const stacksSearchInput = z
  .object({
    query: z.string().trim().min(3).max(2000),
    limit: z.number().int().min(1).max(10).default(5)
  })
  .strict();
const text = z.string().max(20_000);
export const stacksMeta = z.object({
  num_docs: z.number().int().nonnegative(),
  sources: z.array(text).max(200),
  snapshots: z.array(text).max(200)
});
export const researchStatus = z.object({
  state: z.enum(["asleep", "starting", "warming", "ready"]),
  warm_percent: z.number().min(0).max(100).nullable(),
  engine_meta: stacksMeta.nullable()
});
export type StacksStatus = {
  state: "available" | z.infer<typeof researchStatus>["state"];
  checkedAt: string;
  warmPercent: number | null;
  meta: z.infer<typeof stacksMeta> | null;
};
export const stacksResults = z.object({
  ms: z.number().nonnegative(),
  results: z
    .array(
      z.object({
        score: z.number(),
        bm25: z.number(),
        fields: z.object({
          title: text.nullish(),
          authors: z.array(text).max(2000).optional(),
          year: z.number().int().nullish(),
          doi: text.nullish(),
          isbn: text.nullish(),
          pmid: text.nullish(),
          pmcid: text.nullish(),
          source: text.nullish(),
          source_id: text.nullish(),
          venue: text.nullish(),
          volume: text.nullish(),
          issue: text.nullish(),
          first_page: text.nullish(),
          last_page: text.nullish()
        }),
        agreement: z.record(z.string().max(100), z.number()),
        comparison: z
          .record(
            z.string().max(100),
            z.object({
              status: z.enum(["corroborated", "partial", "conflict", "not_observed"]),
              score: z.number(),
              unmatched_tokens: z.array(text).max(2000)
            })
          )
          .optional()
      })
    )
    .max(10)
});
export type StacksResults = z.infer<typeof stacksResults>;
